import { Challenge } from "./challenge";
import { Hash } from "../hash";
import { Utils } from "../utils";

interface PowMdata {
    key: string,
    seed: number,
    mask: string
}

const powKeyLength = 16;

export class PowChallenge extends Challenge {
    private cresValue = "";

    protected async execute(): Promise<boolean> {
        if (!this.mdata && !(await this.getMedia())) { return false; }
        return this.processMdata();
    }
    async render(parentDiv: HTMLElement): Promise<boolean> {
        if (!parentDiv) { return false; }

        const cres = this.getCresElement();
        parentDiv.appendChild(cres);

        if (!(await this.execute())) { return false; }

        cres.value = this.cresValue;

        return true;
    }

    protected processMdata(): boolean {
        if (!this.mdata) { return false; }
        let data: PowMdata;
        try {
            this.mdata = this.mdata.replace(/\\/g, "");
            data = JSON.parse(this.mdata);
            const result = this.solvePow(data.key, data.seed, data.mask);
            this.cresValue = result;
        } catch (e) {
            return false;
        }

        return true;
    }

    // solvePow - solves the PoW Challenge, returning the result
    private solvePow(key: string, seed: number, mask: string): string {
        let result = false;
        let stringToHash = "";
        do {
            stringToHash = key + Utils.randomStringGenerator(key.length, powKeyLength);
            const hashString = Hash.x64hash128(stringToHash, seed);
            result = this.validateAgainstMask(hashString, mask);
        } while (!result);

        return stringToHash;
    }

    // validateAgainstMask - Confirms the PoW hash against the mask
    private validateAgainstMask(hash: string, mask: string): boolean {
        mask = mask || "";
        const hashSubString = hash.substring(0, mask.length);
        const result = hashSubString.localeCompare(mask);
        return result === 0;
    }
}
